<template>
  <div class="row p-0 m-0">
    <!-- 3D -->
    <div class="col-12 col-sm-12 col-md-8">
      <div id="canvas" tabindex="-999"></div>
      <div class="top-open open-label cursor-pointer m-0">
        <label class="m-0 p-0 h-50" for="topOpen">
          <span v-show="configuration.data.topOpen" class="icon-archive-opened-box-outline h-50 active"></span>
          <span v-show="!configuration.data.topOpen" class="icon-archive-outlined-box h-50"></span>
        </label>
        <input type="checkbox" class="d-none" id="topOpen" v-model="configuration.data.topOpen" @change="updateMesh">
      </div>
      <div class="rotate cursor-pointer mr-2">
        <label class="p-0 m-0 h-50" for="control">
          <i v-show="control" class="material-icons h-50 active">3d_rotation</i>
          <i v-show="!control" class="material-icons h-50">3d_rotation</i>
        </label>
        <input type="checkbox" class="d-none" id="control" v-model="control" @change="changeControl">
      </div>
      <div class="reset cursor-pointer mr-2">
        <button type="button" class="btn p-0 m-0 h-50" @click="restoreControl">
          <i class="material-icons h-50" @click="restoreControl">settings_backup_restore</i>
        </button>
      </div>
      <div class="sizes">
        <div class="row m-0">
          <label class="col-12 p-0">ГАБАРИТЫ:</label>
        </div>
        <div class="row m-0">
          <label class="col-8 p-0">длина</label>
          <label class="col-4 p-0">{{ sizeX }} см</label>
        </div>
        <div class="row m-0">
          <label class="col-8 p-0">ширина</label>
          <label class="col-4 p-0">{{ sizeZ }} см</label>
        </div>
        <div class="row m-0">
          <label class="col-8 p-0">высота</label>
          <label class="col-4 p-0">{{ sizeY }} см</label>
        </div>
      </div>
      <Gallery v-if="configurationActive.id >= 0" :configuration="configurationActive"/>
    </div>
    <!-- CONF -->
    <div class="col-12 col-sm-12 col-md-4">
      <h2 class="block-header" data-toggle="collapse" href="#conf" role="button" aria-expanded="false" aria-controls="conf">Конфигуратор</h2>
      <div class="collapse show" id="conf">
        <form class="p-0 m-0" id="accordion" action="#">
          <!-- POCKETS -->
          <a class="form-row" data-toggle="collapse" href="#grips" role="button" aria-expanded="false" aria-controls="grips">
            <i class="material-icons">arrow_drop_down</i>
            Тип изделия
          </a>
          <div class="collapse show pl-4 pr-1" id="grips" data-parent="#accordion">
            <div class="row pt-1 pb-1 m-0">
              <select class="form-control custom-select" id="grips-select" v-model="configuration.data.grips" @change="updateMesh">
                <option value="front-back">сумка</option>
                <option value="bottom-top">чемодан</option>
                <option value="left-right">сундук</option>
                <option value="left-right-pizza">пицца</option>
                <option value="none">короб</option>
              </select>
            </div>
            <div class="row pt-1 pb-1 m-0">
              <label class="col-4 p-0">ручки</label>
              <select class="col-8 form-control custom-select" id="grips-extra-select" v-model="configuration.data.gripsLength" @change="updateMesh">
                <option value="-150">в двух руках</option>
                <option value="0">в одной руке</option>
                <option value="200">на плече</option>
              </select>
            </div>
            <div class="row pt-1 pb-1 m-0">
              <label class="col-9 p-0 cursor-pointer" for="gripsExtra">пристёгивающийся ремень</label>
              <label class="col-3 p-0" for="gripsExtra">
                <i v-if="!configuration.data.gripsExtra" class="material-icons checkbox float-right">check_box_outline_blank</i>
                <i v-if="configuration.data.gripsExtra" class="material-icons checkbox float-right">check_box</i>
              </label>
              <input type="checkbox" class="d-none" id="gripsExtra" v-model="configuration.data.gripsExtra">
            </div>
          </div>

          <!-- MAIN SECTION -->
          <a class="form-row" data-toggle="collapse" href="#shape" role="button" aria-expanded="false" aria-controls="shape">
            <i class="material-icons">arrow_drop_down</i>
            Главная секция
          </a>
          <div class="collapse show pl-4 pr-1" id="shape" data-parent="#accordion">
            <div class="row pt-1 pb-1 m-0">
              <label class="col-8 p-0">длина, см</label>
              <input class="col-4 form-control" v-model.number="configuration.data.sections[0].x" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
            </div>
            <div class="row pt-1 pb-1 m-0">
              <label class="col-8 p-0">ширина, см</label>
              <input class="col-4 form-control" v-model.number="configuration.data.sections[0].z" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
            </div>
            <div class="row pt-1 pb-1 m-0">
              <label class="col-8 p-0">{{ configuration.data.yBound ? "высота, см" : "высота сзади, см"}}</label>
              <input class="col-4 form-control" v-model.number="configuration.data.sections[0].y" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
            </div>
            <div v-if="!configuration.data.yBound" class="row pt-1 pb-1 m-0">
              <label class="col-8 p-0">высота спереди, см</label>
              <input class="col-4 form-control" v-model.number="configuration.data.sections[0].yf" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
            </div>
            <div class="row pt-1 pb-1 m-0">
              <label class="col-9 p-0 cursor-pointer" for="yBound">равная высота</label>
              <label class="col-3 p-0" for="yBound">
                <i v-if="!configuration.data.yBound" class="material-icons checkbox float-right">check_box_outline_blank</i>
                <i v-if="configuration.data.yBound" class="material-icons checkbox float-right">check_box</i>
              </label>
              <input type="checkbox" class="d-none" id="yBound" v-model="configuration.data.yBound" @change="updateMesh">
            </div>
          </div>
          
          <!-- SECTIONS -->
          <a class="form-row" data-toggle="collapse" href="#sections" role="button" aria-expanded="false" aria-controls="sections">
            <i class="material-icons">arrow_drop_down</i>
            Дополнительные секции
          </a>
          <div class="collapse hide pl-4 pr-1" id="sections" data-parent="#accordion">
            <div v-for="(section, index) in configuration.data.sections.slice(1)" :key="'section_' + index">
              <div v-if="section.direction === 'left'" class="form-group row pt-1 pb-1 m-0">
                <label class="col-8 p-0">слева - размер, см</label>
                <div class="input-group col-4 p-0">
                  <input class="form-control" v-model.number="section.x0" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
                  <div class="btn btn-custom p-0" @click="removeSection(section)">
                    <i class="material-icons checkbox">cancel</i>
                  </div>
                </div>
              </div>
              <div v-if="section.direction === 'right'" class="form-group row pt-1 pb-1 m-0">
                <label class="col-8 p-0">справа - размер, см</label>
                <div class="input-group col-4 p-0">
                  <input class="form-control" v-model.number="section.x" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
                  <div class="btn btn-custom p-0" @click="removeSection(section)">
                    <i class="material-icons checkbox">cancel</i>
                  </div>
                </div>
              </div>
              <div v-if="section.direction === 'front'" class="form-group row pt-1 pb-1 m-0">
                <label class="col-8 p-0">спереди - размер, см</label>
                <div class="input-group col-4 p-0">
                  <input class="form-control" v-model.number="section.z" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
                  <div class="btn btn-custom p-0" @click="removeSection(section)">
                    <i class="material-icons checkbox">cancel</i>
                  </div>
                </div>
              </div>
              <div v-if="section.direction === 'back'" class="form-group row pt-1 pb-1 m-0">
                <label class="col-8 p-0">сзади - размер, см</label>
                <div class="input-group col-4 p-0">
                  <input class="form-control" v-model.number="section.z0" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
                  <div class="btn btn-custom p-0" @click="removeSection(section)">
                    <i class="material-icons checkbox">cancel</i>
                  </div>
                </div>
              </div>
              <div v-if="section.direction === 'top'" class="form-group row pt-1 pb-1 m-0">
                <label class="col-8 p-0">сверху - размер, см</label>
                <div class="input-group col-4 p-0">
                  <input class="form-control" v-model.number="section.y" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
                  <div class="btn btn-custom p-0" @click="removeSection(section)">
                    <i class="material-icons checkbox">cancel</i>
                  </div>
                </div>
              </div>
              <div v-if="section.direction === 'bottom'" class="form-group row pt-1 pb-1 m-0">
                <label class="col-8 p-0">снизу - размер, см</label>
                <div class="input-group col-4 p-0">
                  <input class="form-control" v-model.number="section.y0" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
                  <div class="btn btn-custom p-0" @click="removeSection(section)">
                    <i class="material-icons checkbox">cancel</i>
                  </div>
                </div>
              </div>
            </div>

            <hr v-if="configuration.data.sections.length > 1">

            <div class="collapse show" id="new-section">
              <div class="row pt-1 pb-1 m-0">
                <label class="col-8 p-0" for="new-section-select">направление</label>
                <select class="col-4 form-control custom-select" id="new-section-select custom-select" v-model="newSection.direction">
                  <option value="left">слева</option>
                  <option value="right">справа</option>
                  <option value="front">спереди</option>
                  <option value="back">сзади</option>
                  <option value="top">сверху</option>
                  <option value="bottom">снизу</option>
                </select>
              </div>
              <div class="row pt-1 pb-1 m-0">
                <label class="col-8 p-0">размер, см</label>
                <input class="col-4 form-control" v-model="newSection.size" @blur="updateMesh" @keyup.enter="$event.target.blur()" @keydown.enter.prevent="">
              </div>
              <div class="row pt-1 pb-1 m-0">
                <button type="button" class="btn btn-outline-primary w-100" @click="addSection">добавить секцию</button>
              </div>
            </div>
          </div>

          <!-- SECTIONS -->
          <a class="form-row" data-toggle="collapse" href="#materials" role="button" aria-expanded="false" aria-controls="materials">
            <i class="material-icons">arrow_drop_down</i>
            Материалы
          </a>
          <div class="collapse hide pl-4 pr-1" id="materials" data-parent="#accordion">
            <div class="row pt-1 pb-1 m-0">
              <label for="partitions-select">материал внутри:</label>
              <select class="form-control custom-select" id="partitions-select" v-model="configuration.data.materials.inside" @change="updateMesh">
                <option value="-1">Жёлтый велюр</option>
                <option v-for="material in materialsInside" :key="material.id" :value="material.id">{{ material.name }}</option>
              </select>
            </div>
            <div class="row pt-1 pb-1 m-0">
              <label for="partitions-select">материал снаружи:</label>
              <select class="form-control custom-select" id="partitions-select" v-model="configuration.data.materials.outside" @change="updateMesh">
                <option value="-1">Чёрный оксфорд</option>
                <option v-for="material in materialsOutside" :key="material.id" :value="material.id">{{ material.name }}</option>
              </select>
            </div>
            <div class="row pt-1 pb-1 m-0">
              <label for="walls-select">стенки:</label>
              <select class="form-control custom-select" id="walls-select" v-model="configuration.data.layers.walls" @change="updateMesh">
                <option value="0">изолон 10мм</option>
                <option value="1">изолон 10мм + фанера 3мм + изолон 10мм</option>
                <option value="2">изолон 10мм + изолон 10мм</option>
              </select>
            </div>
            <div class="row pt-1 pb-1 m-0">
              <label for="bottom-select">дно:</label>
              <select class="form-control custom-select" id="bottom-select" v-model="configuration.data.layers.bottom" @change="updateMesh">
                <option value="0">изолон 10мм</option>
                <option value="1">изолон 10мм + фанера 3мм + изолон 10мм</option>
                <option value="2">изолон 10мм + изолон 10мм</option>
              </select>
            </div>
            <div class="row pt-1 pb-1 m-0">
              <label for="top-select">крышка:</label>
              <select class="form-control custom-select" id="top-select" v-model="configuration.data.layers.top" @change="updateMesh">
                <option value="0">изолон 10мм</option>
                <option value="1">изолон 10мм + фанера 3мм + изолон 10мм</option>
                <option value="2">изолон 10мм + изолон 10мм</option>
              </select>
            </div>
            <div class="row pt-1 pb-1 m-0">
              <label for="partitions-select">перегородки:</label>
              <select class="form-control custom-select" id="partitions-select" v-model="configuration.data.layers.partitions" @change="updateMesh">
                <option value="0">изолон 10мм</option>
                <option value="1">изолон 10мм + фанера 3мм + изолон 10мм</option>
                <option value="2">изолон 10мм + изолон 10мм</option>
              </select>
            </div>
          </div>
          
          <!-- POCKETS -->
          <a class="form-row" data-toggle="collapse" href="#pockets" role="button" aria-expanded="false" aria-controls="pockets">
            <i class="material-icons">arrow_drop_down</i>
            Карманы
          </a>
          <div class="collapse hide pl-4 pr-1" id="pockets" data-parent="#accordion">
            <div class="form-group row">
              <label class="col-4"></label>
              <label class="col-4 text-center">внутри</label>
              <label class="col-4 text-center">снаружи</label>
            </div>
            <div v-for="(pocket, index) in configuration.data.pockets" :key="'pocket_' + index">
              <div class="form-group row">
                <label class="col-4">{{ directionToLabel(pocket.direction) }}</label>
                <label class="col-4 text-center" :for="'pocket_inside_' + index">
                  <i v-if="!pocket.inside" class="material-icons checkbox">check_box_outline_blank</i>
                  <i v-if="pocket.inside" class="material-icons checkbox">check_box</i>
                </label>
                <input type="checkbox" class="d-none" :id="'pocket_inside_' + index" v-model="pocket.inside" @change="updateMesh">
                <label class="col-4 text-center" :for="'pocket_outside_' + index">
                  <i v-if="!pocket.outside" class="material-icons checkbox">check_box_outline_blank</i>
                  <i v-if="pocket.outside" class="material-icons checkbox">check_box</i>
                </label>
                <input type="checkbox" class="d-none" :id="'pocket_outside_' + index" v-model="pocket.outside" @change="updateMesh">
              </div>
            </div>
          </div>

          <!-- CONF EDIT -->
          <a v-if="isLoggedIn" v-show="categoryActive.id >= 0 || configurationActive.id >= 0" class="form-row" data-toggle="collapse" href="#conf-edit" role="button" aria-expanded="false" aria-controls="conf-edit">
            <i class="material-icons">arrow_drop_down</i>
            Редактирование
          </a>
          <div v-if="isLoggedIn" class="collapse show pl-4 pr-1" id="conf-edit" data-parent="#accordion">
            <input v-show="categoryActive.id >= 0 || configurationActive.id >= 0" class="form-control w-100 mt-2" v-model="configuration.name">
            <button type="button" v-show="categoryActive.id >= 0" class="btn btn-outline-primary w-100 mt-2" @click="$emit('saveConfiguration', configuration)">Сохранить конфигурацию в {{ categoryActive.name }}</button>
            <button type="button" v-show="configurationActive.id >= 0" class="btn btn-outline-primary w-100 mt-2" @click="$emit('saveConfiguration', configuration)">Обновить конфигурацию {{ configurationActive.name }}</button>
            <button type="button" v-show="configurationActive.id >= 0" class="btn btn-outline-danger w-100 mt-2" @click="$emit('deleteConfiguration')">Удалить</button>
            <hr>
            <button type="button" class="btn btn-outline-primary w-100" @click="$emit('saveConfigurationToBuffer')">Сохранить конфигурацию в буфер</button>
            <button type="button" class="btn btn-outline-primary w-100 mt-2" @click="$emit('loadConfigurationFromBuffer')">Загрузить конфигурацию из буфера</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import OrbitControls from "three-orbitcontrols";
import Gallery from "./Gallery";

var cache = {};
var minHeightCache = 0;

class Mesh {
  constructor(configuration, materials, rerender) {
    this.configuration = configuration;
    this.mesh = new THREE.Group();
    this.textures = {};
    this.rerender = rerender;
    this.loadTextures(materials);
    this.createPartitions();
    this.createWalls();
    this.moveToCenter();
    return this.mesh;
  }
  loadTexture(path) {
    if (cache[path] == undefined) {
      var texture = new THREE.TextureLoader().load(path, this.rerender);
      texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
      texture.repeat.set( 0.008, 0.008 );
      cache[path] = texture;
    } else {
      texture = cache[path];
    }
    return texture;
  }
  loadTextures(materials) {
    this.textures.fanera = this.loadTexture('/fanera.jpg');
    this.textures.isolon = this.loadTexture('/isolon.jpg');
    this.textures.grip = this.loadTexture('/grip.jpg');
    if (this.configuration.materials.inside < 0) {
      this.textures.inside = this.loadTexture('/inside.jpg');
    } else {
      materials.forEach(material => {
        if (this.configuration.materials.inside == material.id) {
          this.textures.inside = this.loadTexture(material.file);
        }
      });
    }
    if (this.configuration.materials.outside < 0) {
      this.textures.outside = this.loadTexture('/outside.jpg');
    } else {
      materials.forEach(material => {
        if (this.configuration.materials.outside == material.id) {
          this.textures.outside = this.loadTexture(material.file);
        }
      });
    }
  }
  getPointsByDirection(direction, borders) {
    switch (direction) {
      case 'bottom':
        return [
          new THREE.Vector2(borders.x0 * 10, borders.z0 * 10),
          new THREE.Vector2(borders.x0 * 10, borders.z * 10),
          new THREE.Vector2(borders.x * 10, borders.z * 10),
          new THREE.Vector2(borders.x * 10, borders.z0 * 10),
        ];
      case 'back':
        return [
          new THREE.Vector2(borders.x0 * 10, borders.y0 * 10),
          new THREE.Vector2(borders.x0 * 10, borders.y * 10),
          new THREE.Vector2(borders.x * 10, borders.y * 10),
          new THREE.Vector2(borders.x * 10, borders.y0 * 10),
        ];
      case 'right':
        return [
          new THREE.Vector2(borders.z0 * 10, borders.y0 * 10),
          new THREE.Vector2(borders.z0 * 10, borders.yf * 10),
          new THREE.Vector2(borders.z * 10, borders.y * 10),
          new THREE.Vector2(borders.z * 10, borders.y0 * 10),
        ];
      case 'front':
        return [
          new THREE.Vector2(borders.x0 * 10, borders.y0 * 10),
          new THREE.Vector2(borders.x0 * 10, borders.yf * 10),
          new THREE.Vector2(borders.x * 10, borders.yf * 10),
          new THREE.Vector2(borders.x * 10, borders.y0 * 10),
        ];
      case 'left':
        return [
          new THREE.Vector2(borders.z0 * 10, borders.y0 * 10),
          new THREE.Vector2(borders.z0 * 10, borders.y * 10),
          new THREE.Vector2(borders.z * 10, borders.yf * 10),
          new THREE.Vector2(borders.z * 10, borders.y0 * 10),
        ];
      case 'top':
        return [
          new THREE.Vector2(borders.x0 * 10, 0),
          new THREE.Vector2(borders.x * 10, 0),
          new THREE.Vector2(borders.x * 10, Math.sqrt(Math.pow(borders.y * 10 - borders.yf * 10, 2) + Math.pow(borders.z * 10 - borders.z0 * 10, 2))),
          new THREE.Vector2(borders.x0 * 10, Math.sqrt(Math.pow(borders.y * 10 - borders.yf * 10, 2) + Math.pow(borders.z * 10 - borders.z0 * 10, 2))),
        ];
      default:
        return [];
    }
  }
  getPointsForGrip(width, height) {
    return [
      new THREE.Vector2(0, 0),
      new THREE.Vector2(0, height),
      new THREE.Vector2(width, height),
      new THREE.Vector2(width, 0),
    ];
  }
  getPocketByDirection(direction) {
    var data = {}
    this.configuration.pockets.forEach(pocket => {
      if (direction == pocket.direction)
        data = pocket;
    });
    return data;
  }
  formLayers(layers, isWall = true) {
    var data = [];
    data.push({ depth: 1, texture: this.textures.inside });
    data.push({ depth: 10, texture: this.textures.isolon });
    if (layers == 1) {
      data.push({ depth: 3, texture: this.textures.fanera });
      data.push({ depth: 10, texture: this.textures.isolon });
    } else if (layers == 2) {
      data.push({ depth: 10, texture: this.textures.isolon });
    }
    if (isWall) {
      data.push({ depth: 1, texture: this.textures.outside });
    } else {
      data.push({ depth: 1, texture: this.textures.inside });
    }
    return data;
  }
  createWall(direction, points, layers, currentBorders, topOpen = false, isWall = true) {
    var wall = new THREE.Group();
    var pocket = this.getPocketByDirection(direction);
    var shape = new THREE.Shape(points);
    var depth = 0;
    var geometry;
    var material;
    var mesh;
    var gripWidth = 40;
    var gripBottom = 200;
    var gripBottomMax = 240;
    var gripHeight = this.configuration.gripsHeight * 10;
    var gripLength = Number.parseInt(this.configuration.gripsLength) || 0;

    // карман внутри
    if (isWall && pocket.inside) {
      material = new THREE.LineBasicMaterial({ color: '#fff', linewidth: 1 });
      geometry = new THREE.ExtrudeGeometry(shape, {depth: 0.1, bevelEnabled: false});
      geometry = new THREE.EdgesGeometry(geometry);
      geometry.computeBoundingBox();
      mesh = new THREE.Line(geometry, material)
      mesh.position.z -= 1;
      mesh.position.x += (geometry.boundingBox.max.x + geometry.boundingBox.min.x) * 0.1;
      mesh.position.y += (geometry.boundingBox.max.y + geometry.boundingBox.min.y) * 0.1;
      mesh.geometry.scale(0.8, 0.8, 1);
      wall.add(mesh);
    }

    // слои
    layers = this.formLayers(layers, isWall);
    layers.forEach(layer => {
      geometry = new THREE.ExtrudeGeometry(shape, {depth: layer.depth, bevelEnabled: false});
      material = new THREE.MeshLambertMaterial({ map: layer.texture });
      mesh = new THREE.Mesh(geometry, material);
      mesh.position.z += depth;
      depth += layer.depth;
      wall.add(mesh);
    });

    // карман снаружи
    if (isWall && pocket.outside) {
      material = new THREE.LineBasicMaterial({ color: '#fff', linewidth: 1 });
      geometry = new THREE.ExtrudeGeometry(shape, {depth: 0.1, bevelEnabled: false});
      geometry = new THREE.EdgesGeometry(geometry);
      geometry.computeBoundingBox();
      mesh = new THREE.Line(geometry, material)
      mesh.position.z += depth;
      mesh.position.x += (geometry.boundingBox.max.x + geometry.boundingBox.min.x) * 0.1;
      mesh.position.y += (geometry.boundingBox.max.y + geometry.boundingBox.min.y) * 0.1;
      mesh.geometry.scale(0.8, 0.8, 1);
      wall.add(mesh);
    }

    // ручки
    material = new THREE.MeshPhongMaterial({ map: this.textures.grip });
    geometry = new THREE.ExtrudeGeometry(shape, {depth: 1, bevelEnabled: false});
    geometry.computeBoundingBox();
    var extraWidth = geometry.boundingBox.min.x;
    var extraHeight = geometry.boundingBox.min.y;
    var width = geometry.boundingBox.max.x - geometry.boundingBox.min.x;
    var height = geometry.boundingBox.max.y - geometry.boundingBox.min.y;
    var minHeight = Math.min(points[1].y, points[2].y) - points[0].y; // минимальная высота боковых стенок для пиццы
    // ВАЖНО! левая стенка должна строиться перед задней, иначе пицца не сработает правильно
    if (direction == 'left')
      minHeightCache = minHeight;
    if (width > 340) {
      gripBottom = gripBottomMax;
    }
    if (this.configuration.grips == 'left-right-pizza') {
      gripBottom = minHeight - 2 * gripWidth;
      if (gripBottom > 240)
        gripBottom = 240;
    }
    gripHeight = height + gripHeight + gripLength - gripBottom / 2;
    if (this.configuration.grips == 'left-right-pizza')
      gripHeight = width + gripLength;
    if (isWall && this.configuration.grips.split('-').includes(direction)) {
      // ленты на стенке
      // если крышка открыта, то не показываем верхнюю часть задней ручки
      if (topOpen && direction == 'back')
        gripHeight = height
      shape = new THREE.Shape(this.getPointsForGrip(gripWidth, gripHeight));
      geometry = new THREE.ExtrudeGeometry(shape, {depth: 1, bevelEnabled: false});
      mesh = new THREE.Mesh(geometry, material);
      if (this.configuration.grips == 'left-right-pizza') {
        mesh.position.z += depth;
        if (direction == 'left') {
          mesh.rotation.z += - Math.PI / 2;
          mesh.position.x -= width;
          mesh.position.y += gripWidth;
        } else {
          mesh.rotation.z += Math.PI / 2;
        }
        mesh.position.x += width;
        mesh.position.y += (minHeight - gripBottom - 2 * gripWidth) / 2 + extraHeight;
      } else {
        mesh.position.x += (width - gripBottom - 2 * gripWidth) / 2 + extraWidth;
        mesh.position.y += extraHeight;
        mesh.position.z += depth;
      }
      wall.add(mesh);
      mesh = new THREE.Mesh(geometry, material);
      if (this.configuration.grips == 'left-right-pizza') {
        mesh.position.z += depth;
        if (direction == 'left') {
          mesh.rotation.z += - Math.PI / 2;
          mesh.position.x -= width;
          mesh.position.y += gripWidth;
        } else {
          mesh.rotation.z += Math.PI / 2;
        }
        mesh.position.x += width;
        mesh.position.y += (minHeight - gripBottom - 2 * gripWidth) / 2 + gripWidth + gripBottom + extraHeight;
      } else {
        mesh.position.x += (width - gripBottom - 2 * gripWidth) / 2 + gripWidth + gripBottom + extraWidth;
        mesh.position.y += extraHeight;
        mesh.position.z += depth;
      }
      wall.add(mesh);

      // овальная лента над стенкой
      var curveInside = new THREE.EllipseCurve(
        0,  0, gripBottom / 2, gripBottom / 2,
        0,  Math.PI, false, 0
      );
      var curveOutside = new THREE.EllipseCurve(
        0,  0, gripBottom / 2 + 40, gripBottom / 2 + 40,
        0,  Math.PI, false, 0
      );
      points = curveOutside.getPoints(20);
      points = points.concat(curveInside.getPoints(20).reverse());
      shape = new THREE.Shape(points);
      geometry = new THREE.ExtrudeGeometry(shape, {depth: 1, bevelEnabled: false});
      mesh = new THREE.Mesh(geometry, material);
      if (this.configuration.grips == 'left-right-pizza') {
        mesh.position.z += depth;
        if (direction == 'left') {
          mesh.rotation.z += - Math.PI / 2;
          mesh.position.x += width + gripLength;
        } else {
          mesh.rotation.z += Math.PI / 2;
          mesh.position.x -= gripLength;
        }
        mesh.position.y += (minHeight - gripBottom - 2 * gripWidth) / 2 + gripWidth + gripBottom / 2 + extraHeight;
      } else {
        mesh.position.x += (width - gripBottom - 2 * gripWidth) / 2 + gripBottom / 2 + gripWidth + extraWidth;
        mesh.position.y += gripHeight + extraHeight;
        mesh.position.z += depth;
      }
      // если крышка открыта, то не показываем верхнюю часть задней ручки
      if (!(topOpen && direction == 'back')) {
        wall.add(mesh);
      }
    }
    // ленты между ручками
    if (isWall && (direction == 'bottom' && this.configuration.grips == 'front-back' || direction == 'back' && this.configuration.grips == 'bottom-top')) {
      shape = new THREE.Shape(this.getPointsForGrip(gripWidth, height));
      geometry = new THREE.ExtrudeGeometry(shape, {depth: 1, bevelEnabled: false});
      mesh = new THREE.Mesh(geometry, material);
      mesh.position.x += (width - gripBottom - 2 * gripWidth) / 2 + extraWidth;
      mesh.position.y += extraHeight;
      mesh.position.z += depth;
      wall.add(mesh);
      mesh = new THREE.Mesh(geometry, material);
      mesh.position.x += (width - gripBottom - 2 * gripWidth) / 2 + gripWidth + gripBottom + extraWidth;
      mesh.position.y += extraHeight;
      mesh.position.z += depth;
      wall.add(mesh);
    }
    if (isWall && direction == 'bottom' && this.configuration.grips == 'left-right') {
      if (height > 340) {
        gripBottom = gripBottomMax;
      }
      shape = new THREE.Shape(this.getPointsForGrip(gripWidth, width));
      geometry = new THREE.ExtrudeGeometry(shape, {depth: 1, bevelEnabled: false});
      mesh = new THREE.Mesh(geometry, material);
      mesh.rotation.z += Math.PI / 2;
      mesh.position.y += (height - gripBottom - 2 * gripWidth) / 2 + extraHeight;
      mesh.position.x += width + extraWidth;
      mesh.position.z += depth;
      wall.add(mesh);
      mesh = new THREE.Mesh(geometry, material);
      mesh.rotation.z += Math.PI / 2;
      mesh.position.y += (height - gripBottom - 2 * gripWidth) / 2 + gripWidth + gripBottom + extraHeight;
      mesh.position.x += width + extraWidth;
      mesh.position.z += depth;
      wall.add(mesh);
    }
    if (isWall && direction == 'back' && this.configuration.grips == 'left-right-pizza') {
      gripBottom = minHeightCache - 2 * gripWidth;
      if (gripBottom > 240)
        gripBottom = 240;
      shape = new THREE.Shape(this.getPointsForGrip(gripWidth, width));
      geometry = new THREE.ExtrudeGeometry(shape, {depth: 1, bevelEnabled: false});
      mesh = new THREE.Mesh(geometry, material);
      window.console.log(minHeightCache);
      mesh.rotation.z += Math.PI / 2;
      mesh.position.y += (minHeightCache - gripBottom - 2 * gripWidth) / 2 + extraHeight;
      mesh.position.x += width;
      mesh.position.z += depth;
      wall.add(mesh);
      mesh = new THREE.Mesh(geometry, material);
      mesh.rotation.z += Math.PI / 2;
      mesh.position.y += (minHeightCache - gripBottom - 2 * gripWidth) / 2 + gripWidth + gripBottom + extraHeight;
      mesh.position.x += width;
      mesh.position.z += depth;
      wall.add(mesh);
    }

    // повороты
    if (direction == 'bottom') {
      wall.rotation.x = Math.PI / 2;
      wall.position.y += currentBorders.y0 * 10;
    } else if (direction == 'back') {
      wall.rotation.y = Math.PI;
      wall.position.x += currentBorders.x * 10 + currentBorders.x0 * 10;
      wall.position.z += currentBorders.z0 * 10;
    } else if (direction == 'right') {
      wall.rotation.y = Math.PI / 2;
      wall.position.x += currentBorders.x * 10;
      wall.position.z += currentBorders.z * 10 + currentBorders.z0 * 10;
    } else if (direction == 'front') {
      wall.position.z += currentBorders.z * 10;
    } else if (direction == 'left') {
      wall.rotation.y = -Math.PI / 2;
      wall.position.x += currentBorders.x0 * 10;
    } else if (direction == 'top') {
      if (topOpen) {
        wall.rotation.x = -Math.PI / 6;
        wall.rotation.y = Math.PI;
        wall.position.y += currentBorders.y * 10;
        wall.position.x += currentBorders.x * 10 + currentBorders.x0 * 10;
        wall.position.z += currentBorders.z0 * 10;
      } else {
        wall.rotation.x = -Math.PI / 2 + Math.atan((this.borders.y - this.borders.yf) / (this.borders.z - this.borders.z0));
        wall.rotation.z = -Math.PI;
        wall.position.y += currentBorders.y * 10;
        wall.position.x += currentBorders.x * 10 + currentBorders.x0 * 10;
        wall.position.z += currentBorders.z0 * 10;
      }
    }
    return wall;
  }
  createWalls() {
    // ВАЖНО! левая сторона должна строиться перед задней, иначе пицца не сработает правильно
    var points = this.getPointsByDirection('bottom', this.borders);
    this.mesh.add(this.createWall('bottom', points, this.configuration.layers.bottom, this.borders));
    points = this.getPointsByDirection('left', this.borders);
    this.mesh.add(this.createWall('left', points, this.configuration.layers.walls, this.borders));
    points = this.getPointsByDirection('back', this.borders);
    this.mesh.add(this.createWall('back', points, this.configuration.layers.walls, this.borders, this.configuration.topOpen));
    points = this.getPointsByDirection('right', this.borders);
    this.mesh.add(this.createWall('right', points, this.configuration.layers.walls, this.borders));
    points = this.getPointsByDirection('front', this.borders);
    this.mesh.add(this.createWall('front', points, this.configuration.layers.walls, this.borders));
    points = this.getPointsByDirection('top', this.borders);
    this.mesh.add(this.createWall('top', points, this.configuration.layers.top, this.borders, this.configuration.topOpen));
  }
  createPartitions() {
    this.borders = JSON.parse(JSON.stringify(this.configuration.sections[0]));
    this.configuration.sections.slice(1).forEach(section => {
      var points = this.getPointsByDirection(section.direction, this.borders);
      this.mesh.add(this.createWall(section.direction, points, this.configuration.layers.partitions, this.borders, false, false));
      this.borders.x += section.x;
      this.borders.x0 -= section.x0;
      this.borders.y += section.z0 * (this.borders.y - this.borders.yf) / (this.borders.z - this.borders.z0) + section.y;
      this.borders.yf -= section.z * (this.borders.y - this.borders.yf) / (this.borders.z - this.borders.z0) - section.yf;
      this.borders.y0 -= section.y0;
      this.borders.z += section.z;
      this.borders.z0 -= section.z0;
    });
  }
  moveToCenter() {
    this.mesh.position.x -= (this.borders.x * 10 + this.borders.x0 * 10) / 2;
    this.mesh.position.y -= (this.borders.yf * 10 + this.borders.y0 * 10) / 2;
    this.mesh.position.z -= (this.borders.z * 10 + this.borders.z0 * 10) / 2;
  }
}

export default {
  name: 'Configurator',
  props: {
    configuration: Object,
    configurationActive: Object,
    categoryActive: Object,
    materials: Array,
  },
  data() {
    return {
      container: undefined,
      camera: undefined,
      scene: undefined, 
      renderer: undefined,
      controls: undefined,
      mesh: undefined,

      cameraX: 800,
      cameraY: 800,
      cameraZ: 1400,

      control: true,

      configuration_old: {},
      newSection: {
        direction: 'right',
        size: 10,
      },
      newPocket: {
        direction: 'top',
        side: 'inside',
      },
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn();
    },
    materialsInside() {
      return this.materials.filter(material => material.is_inside == true);
    },
    materialsOutside() {
      return this.materials.filter(material => material.is_outside == true);
    },
    sizeX() {
      var x = 0;
      var x0 = 0;
      var layersCount = -1;
      this.configuration.data.sections.forEach(layer => {
        x += layer.x;
        x0 += layer.x0;
        if (layer.x > 0 || layer.x0 > 0)
          layersCount += 1;
      })
      return x + x0 + (this.configuration.data.layers.partitions == 0 ? 1 : 2) * layersCount + (this.configuration.data.layers.walls == 0 ? 1 : 2) * 2;
    },
    sizeY() {
      var y = 0;
      var y0 = 0;
      var yf = 0;
      var layersCount = -1;
      this.configuration.data.sections.forEach(layer => {
        y += layer.y;
        y0 += layer.y0;
        yf += layer.yf;
        if (layer.y > 0 || layer.y0 > 0 || layer.yf)
          layersCount += 1;
      })
      return Math.max(y, yf) + y0 + (this.configuration.data.layers.partitions == 0 ? 1 : 2) * layersCount + (this.configuration.data.layers.top == 0 ? 1 : 2) + (this.configuration.data.layers.bottom == 0 ? 1 : 2);
    },
    sizeZ() {
      var z = 0;
      var z0 = 0;
      var layersCount = -1;
      this.configuration.data.sections.forEach(layer => {
        z += layer.z;
        z0 += layer.z0;
        if (layer.z > 0 || layer.z0 > 0)
          layersCount += 1;
      })
      return z + z0 + (this.configuration.data.layers.partitions == 0 ? 1 : 2) * layersCount + (this.configuration.data.layers.walls == 0 ? 1 : 2) * 2;
    },
  },
  watch: {
    configuration: {
      handler() {
        if (this.configuration.data.yBound) {
          if (this.configuration.data.sections[0].yf != this.configuration.data.sections[0].y) { 
            this.configuration.data.sections[0].yf = this.configuration.data.sections[0].y;
            this.configuration.forse_reload = true;
          }
        }
        if (this.configuration.id != this.configuration_old.id) {
          this.updateMesh();
        } else if (this.configuration.forse_reload == true) {
          this.updateMesh();
        }
        this.configuration_old = JSON.parse(JSON.stringify(this.configuration));
      },
      deep: true,
    },
  },
  methods: {
    init() {
      this.container = document.getElementById('canvas');

      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(this.container.offsetWidth, this.container.offsetHeight);
      
      this.renderer.setClearColor(0xffffff, 0);
      this.container.appendChild(this.renderer.domElement);

      this.scene = new THREE.Scene();
      this.camera = new THREE.PerspectiveCamera(50, this.container.offsetWidth / this.container.offsetHeight, 10, 90000);
      this.camera.position.x = this.cameraX;
      this.camera.position.y = this.cameraY;
      this.camera.position.z = this.cameraZ;

      // light
      const lightRight = new THREE.SpotLight(0xffffff, 0.1);
      lightRight.position.set(2000, 2000, 200);
      this.scene.add(lightRight);

      const lightLeft = new THREE.SpotLight(0xffffff, 0.1);
      lightLeft.position.set(-2000, 2000, 200);
      this.scene.add(lightLeft);

      const lightAmbient = new THREE.AmbientLight(0xffffff, 1);
      this.scene.add(lightAmbient);

      // for rotation
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableKeys = false;
      this.controls.rotateSpeed = 0.5;
      this.controls.saveState();
      this.changeControl();

      // create mesh
      this.updateMesh();

      // resize event
      window.addEventListener('resize', this.onResize, false);
    },
    updateMesh() {
      // remove mesh
      this.scene.remove(this.mesh);
      // add new mesh
      this.mesh = new Mesh(this.configuration.data, this.materials, this.render);
      this.scene.add(this.mesh);
      // render
      this.render();
    },
    changeControl() {
      if (this.control) {
        this.controls.enabled = true;
        this.controls.update();
        this.animate();
      } else {
        this.controls.enabled = false;
        this.controls.update();
      }
    },
    restoreControl() {
      this.controls.reset();
    },
    onResize() {
      this.camera.aspect = this.container.offsetWidth / this.container.offsetHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(this.container.offsetWidth, this.container.offsetHeight);
      this.render();
    },
    render() {
      this.renderer.render(this.scene, this.camera);
    },
    animate() {
      if (this.control) {
        requestAnimationFrame(this.animate);
        this.render();
      }
    },
    addSection() {
      var data = { direction: this.newSection.direction, x: 0, x0: 0, y: 0, yf: 0, y0: 0, z: 0, z0: 0 };
      var size = Number.parseInt(this.newSection.size);
      if (this.newSection.direction == 'left') {
        data.x0 = size;
      } else if (this.newSection.direction == 'right') {
        data.x = size;
      } else if (this.newSection.direction == 'front') {
        data.z = size;
      } else if (this.newSection.direction == 'back') {
        data.z0 = size;
      } else if (this.newSection.direction == 'top') {
        data.y = size;
        data.yf = size;
      } else if (this.newSection.direction == 'bottom') {
        data.y0 = size;
      }
      this.configuration.data.sections.push(data);
      this.updateMesh();
    },
    removeSection(section) {
      this.configuration.data.sections.splice(this.configuration.data.sections.indexOf(section), 1);
      this.updateMesh();
    },
    directionToLabel(direction) {
      switch(direction) {
        case "left":
          return "слева";
        case "right":
          return "справа";
        case "back":
          return "сзади";
        case "front":
          return "спереди";
        case "bottom":
          return "снизу";
        case "top":
          return "сверху";
      }
    },
  },
  mounted() {
    if (this.$store.getters.getWindowWidth() < 768)
      this.control = false;
    this.init();
    this.configuration_old = JSON.parse(JSON.stringify(this.configuration));
  },
  components: {
    Gallery,
  },
}
</script>
